import { useState } from 'react';
import type { CitizenCardData } from '../types/citizen';

interface CitizenAvatarProps {
  citizen: CitizenCardData['citizen'];
}

export function CitizenAvatar({ citizen }: CitizenAvatarProps) {
  const [failed, setFailed] = useState(false);
  const initials = citizen.username
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase();

  return (
    <div className="citizen-avatar" aria-label={`${citizen.username}'s character portrait`}>
      {!failed && citizen.avatarUrl ? (
        <img
          className="citizen-avatar__image"
          src={citizen.avatarUrl}
          alt=""
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="citizen-avatar__fallback" aria-hidden="true">
          {initials || 'EC'}
        </span>
      )}
      {citizen.avatarBorderUrl ? (
        <img className="citizen-avatar__border" src={citizen.avatarBorderUrl} alt="" />
      ) : null}
      <span className="citizen-avatar__seal" aria-hidden="true">E</span>
    </div>
  );
}

